import config from "../../config";

export default {
  AUTH: {
    LOGIN: `${config.baseApiUrl}auth/login`,
    VERIFY: `${config.baseApiUrl}auth/verify-user`,
    REGISTER: `${config.baseApiUrl}auth/register`,
    FORGOT_PASSWORD: `${config.baseApiUrl}auth/forgot-password`,
    SET_PASSWORD: `${config.baseApiUrl}auth/set-password`,
  },
  USER: {
    GET_USERS: `${config.baseApiUrl}users`,
    GET_USER_DETAILS: `${config.baseApiUrl}users/details`,
    GET_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    CREATE_USER: `${config.baseApiUrl}users`,
    UPDATE_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    UPDATE_USER_STATUS: (id: string) => `${config.baseApiUrl}users/${id}/status`,
  },
  SENSOR: {
    GET_SENSORS: `${config.baseApiUrl}sensors`,
    CREATE_SENSOR: `${config.baseApiUrl}sensors`,
    UPDATE_SENSOR: (id: string) => `${config.baseApiUrl}sensors/${id}`,
    UPDATE_SENSOR_STATUS: (id: string) => `${config.baseApiUrl}sensors/${id}/status`,
  },
  STATION: {
    GET_STATIONS: `${config.baseApiUrl}stations`,
    GET_STATIONS_ISSUES: `${config.baseApiUrl}stations/issues`,
    GET_STATIONS_CONNECTIONS: `${config.baseApiUrl}stations/connections`,
    READ_STATION_ISSUE: (id: string) => `${config.baseApiUrl}stations/issues/${id}`,
    GET_STATION: (id: string) => `${config.baseApiUrl}stations/${id}`,
    GET_STATION_RAW_DATA: (id: string) => `${config.baseApiUrl}stations/${id}/raw-data`,
    CREATE_STATION: `${config.baseApiUrl}stations`,
    UPDATE_STATION: (id: string) => `${config.baseApiUrl}stations/${id}`,
    ACTIVATE_DEACTIVATE_STATION: (id: string) => `${config.baseApiUrl}stations/${id}/activate`,
  },
  ALERT: {
    GET_ALERTS: `${config.baseApiUrl}alerts/settings`,
    GET_ALERT_NOTIFICATIONS: `${config.baseApiUrl}alerts/notifications`,
    CREATE_ALERT: `${config.baseApiUrl}alerts/settings`,
    CREATE_USER_ALERT: (id: string) => `${config.baseApiUrl}users/${id}/alerts/settings`,
    READ_ALERT_NOTIFICATION: (id: string) => `${config.baseApiUrl}alerts/notifications/${id}/read`,
  },
  SENSOR_DATA_FILE: {
    GET_SENSOR_DATA_FILES: `${config.baseApiUrl}sensor-data-files`,
    GET_SENSOR_DATA_FILE: (id: string) => `${config.baseApiUrl}sensor-data-files/${id}`,
    GET_SENSOR_DATA_FILE_VALUES: (id: string) => `${config.baseApiUrl}sensor-data-files/${id}/values`,
    CREATE_SENSOR_DATA_FILE: `${config.baseApiUrl}sensor-data-files`,
  },
  SENSOR_DATA_RESTORING_REQUEST: {
    GET_SENSOR_DATA_RESTORING_REQUESTS: `${config.baseApiUrl}sensor-data-restoring-requests`,
    GET_SENSOR_DATA_RESTORING_REQUEST: (id: string) => `${config.baseApiUrl}sensor-data-restoring-requests/${id}`,
    DOWNLOAD_SENSOR_DATA_RESTORING_REQUEST: (id: string) =>
      `${config.baseApiUrl}sensor-data-restoring-requests/${id}/download`,
    RESTORE_SENSOR_DATA_RESTORING_REQUEST: (id: string) =>
      `${config.baseApiUrl}sensor-data-restoring-requests/${id}/restore`,
    DELETE_SENSOR_DATA_RESTORING_REQUEST: (id: string) => `${config.baseApiUrl}sensor-data-restoring-requests/${id}`,
    CREATE_SENSOR_DATA_RESTORING_REQUESTS: `${config.baseApiUrl}sensor-data-restoring-requests`,
  },
  SENSOR_DATA_SESSIONS: {
    GET_SENSOR_DATA_SESSIONS: `${config.baseApiUrl}sensor-data-sessions`,
    CREATE_SENSOR_DATA_SESSION: `${config.baseApiUrl}sensor-data-sessions`,
    GET_SENSOR_DATA_SESSION: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}`,
    GET_SENSOR_DATA_SESSION_VALUES: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}/values`,
    DOWNLOAD_SENSOR_DATA_SESSION_VALUES: (id: number) =>
      `${config.baseApiUrl}sensor-data-sessions/${id}/values/download`,
    GET_SENSOR_DATA_SESSION_PROCESSED_VALUES: (id: string) =>
      `${config.baseApiUrl}sensor-data-sessions/${id}/processed-values`,
    DELETE_SENSOR_DATA_SESSION: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}`,
    UPDATE_SENSOR_DATA_SESSION: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}`,
    CREATE_SENSOR_DATA_SESSION_MARKER: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}/markers`,
    DELETE_SENSOR_DATA_SESSION_MARKER: (id: string, markerId: string) =>
      `${config.baseApiUrl}sensor-data-sessions/${id}/markers/${markerId}`,
    GET_SENSOR_DATA_SESSION_MARKERS: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}/markers`,
    GET_SENSOR_DATA_SESSION_DOTS: (id: string) => `${config.baseApiUrl}sensor-data-sessions/${id}/dots`,
    CREATE_SENSOR_DATA_SESSION_MARKER_DOT: (id: string, markerId: string) =>
      `${config.baseApiUrl}sensor-data-sessions/${id}/markers/${markerId}/dots`,
    DELETE_SENSOR_DATA_SESSION_MARKER_DOT: (id: string, markerId: string, dotId: string) =>
      `${config.baseApiUrl}sensor-data-sessions/${id}/markers/${markerId}/dots/${dotId}`,
  },
  PATIENT: {
    IMPORT_PATIENTS: `${config.baseApiUrl}patients/import`,
    GET_PATIENTS: `${config.baseApiUrl}patients`,
    CREATE_PATIENT: `${config.baseApiUrl}patients`,
    GET_PATIENT: (id: string) => `${config.baseApiUrl}patients/${id}`,
    UPDATE_PATIENT: (id: string) => `${config.baseApiUrl}patients/${id}`,
    UPDATE_PATIENT_STATUS: (id: string) => `${config.baseApiUrl}patients/${id}/status`,
    GET_PATIENT_SENSORS_AVERAGE_DATA: (id: string) => `${config.baseApiUrl}patients/${id}/average-data`,
    GET_PATIENT_DETAILED_SENSORS_DATA: (id: string) => `${config.baseApiUrl}patients/${id}/detailed-sensors-data`,
  },
  HOSPIATAL: {
    GET_HOSPIATALS: `${config.baseApiUrl}hospitals`,
    GET_HOSPIATAL: (id: string) => `${config.baseApiUrl}hospitals/${id}`,

    GET_HOSPIATAL_FORMS_SETTINGS: (id: string) => `${config.baseApiUrl}hospitals/${id}/forms`,
    UPDATE_HOSPIATAL_FORM_SETTING: (id: string, formId: string) =>
      `${config.baseApiUrl}hospitals/${id}/forms/${formId}/settings`,
    GET_HOSPIATAL_PERMISSIONS: (id: string) => `${config.baseApiUrl}hospitals/${id}/permissions`,
    UPDATE_HOSPIATAL_PERMISSION: (id: string, permissionId: string) =>
      `${config.baseApiUrl}hospitals/${id}/permissions/${permissionId}`,
    UPDATE_HOSPIATAL: (id: string) => `${config.baseApiUrl}hospitals/${id}`,
  },
  REPORT: {
    SESSIONS_REPORT: (id: string) => `${config.baseApiUrl}hospitals/${id}/reports/sessions`,
    FORMS_REPORT: (id: string) => `${config.baseApiUrl}hospitals/${id}/reports/forms`,
    SENSORS_DATA_REPORT: (id: string) => `${config.baseApiUrl}hospitals/${id}/reports/sensors-data`,
    DETAILED_SENSORS_DATA_REPORT: (id: string) => `${config.baseApiUrl}hospitals/${id}/reports/detailed-sensors-data`,
    DETAILED_UNFILTERED_SENSORS_DATA_REPORT: (id: string) =>
      `${config.baseApiUrl}hospitals/${id}/reports/detailed-unfiltered-sensors-data`,
  },
  SHARED: {
    GET_ROLES: `${config.baseApiUrl}shared/roles/`,
    GET_PERMISSIONS: `${config.baseApiUrl}shared/permissions/`,
  },
  USER_SESSION: {
    CREATE_USER_SESSION: `${config.baseApiUrl}user-sessions`,
    UPDATE_USER_SESSION: (id: string) => `${config.baseApiUrl}user-sessions/${id}`,
  },
};
